import { render, staticRenderFns } from "./menuItemImage.vue?vue&type=template&id=3d0ddaa2&scoped=true"
import script from "./menuItemImage.vue?vue&type=script&lang=js"
export * from "./menuItemImage.vue?vue&type=script&lang=js"
import style0 from "./menuItemImage.vue?vue&type=style&index=0&id=3d0ddaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ddaa2",
  null
  
)

export default component.exports